/**
 *  Align cells within the carousel element.
 *  "left", "center", "right"
 */
var CellAlign;
(function (CellAlign) {
    CellAlign["left"] = "left";
    CellAlign["center"] = "center";
    CellAlign["right"] = "right";
})(CellAlign || (CellAlign = {}));
/**
 *  CAROUSEL CONFIG
 *  Configuration object to create the slider:
 *
 *  @param {string} sliderSelector - querySelector of carousel. Choose [data-carousel] if you want to select all carousel.
 *  @param {CellAlign} cellAlign - Align cells within the carousel element. Choose "left", "center", "right".
 *  @param {boolean} contain - Contains cells to carousel element to prevent excess scroll at beginning or end. Has no effect if wrapAround: true
 *  @param {boolean | number} autoPlay - Automatically advances to the next cell.
 *  @param {boolean} wrapAround - At the end of cells, wrap-around to the other end for infinite scrolling.
 *  @param {boolean} showArrows - Display or not the built-in arrows of the carousel.
 *  @param {boolean} showDots - Display or not the built-in dots of the carousel.
 *  @param {boolean} groupCells - Groups cells together in slides. Flicking, page dots, and previous/next buttons are mapped to group slides, not individual cells. is-selected class is added to the multiple cells in the selected slide.
 *  @param {boolean} adaptiveHeight - Changes the slider's height based on slide's height
 *  @param {boolean} imagesLoaded - Unloaded images have no size, which can throw off cell positions. To fix this, the imagesLoaded option re-positions cells once their images have loaded.
 *  @param {number} viewport - An optional parameter to decide at which viewport the carousel should be activated
 *  @param {number} destroyViewport - An optional parameter to decide at which viewport the carousel should be destroyed.
 *
 */
class CarouselConfig {
}
class ResponsiveCarousel {
    constructor() {
        /**
         *  CREATE CAROUSEL
         *
         *  Here are all the configurations to create the Flickity slider.
         */
        this.createCarousel = (carousel, config) => {
            if (carousel && config) {
                return new Flickity(carousel, {
                    on: {
                        ready: function () {
                            carousel.setAttribute("data-carousel", "active");
                        }
                    },
                    //slider options
                    cellAlign: config.cellAlign.toString(),
                    contain: config.contain,
                    autoPlay: config.autoPlay,
                    wrapAround: config.wrapAround,
                    prevNextButtons: config.showArrows,
                    pageDots: config.showDots,
                    groupCells: config.groupCells,
                    adaptiveHeight: config.adaptiveHeight,
                    imagesLoaded: config.imagesLoaded,
                    arrowShape: config.arrowShape
                });
            }
        };
        /**
         *  INIT CAROUSEL
         *
         *  If the container can't contain all the slides then the carousel will be initialized
         *  You must add the attribute data-slide to every slide of the slider
         */
        this.initCarousel = (config) => {
            const createdSlidersArray = [];
            if (window.innerWidth <= config.viewport || !config.viewport) {
                const carouselsList = document.querySelectorAll(config.sliderSelector);
                if (carouselsList && carouselsList.length > 0) {
                    carouselsList.forEach((carousel) => {
                        const sliderItemsList = carousel.querySelectorAll("[data-slide]");
                        if (sliderItemsList.length > 1) {
                            //Max number of slides that could exist into the slider
                            const maxNumberOfItems = (carousel.getBoundingClientRect().width) / (sliderItemsList[0].getBoundingClientRect().width);
                            //Array of slider's items (How many slide there are on the carousel)
                            const actualSliderItemsNumber = sliderItemsList.length;
                            /*console.log(`${actualSliderItemsNumber} > ${maxNumberOfItems}`);*/
                            //If maxNumberOfItems is less than actualSliderItemsNumber then initialize slider carousel or add a class to center item
                            if (actualSliderItemsNumber > maxNumberOfItems) {
                                if (window.innerWidth > config.destroyViewport || !config.destroyViewport) {
                                    const flickitySlider = this.createCarousel(carousel, config);
                                    const buttonsContainer = carousel.parentElement.querySelector("[data-custom-buttons-container]");
                                    const counterContainer = carousel.parentElement.querySelector("[data-counter]");
                                    if (buttonsContainer) {
                                        this.bindFlickityButtons(buttonsContainer, flickitySlider);
                                    }
                                    if (counterContainer) {
                                        this.bindFlickityCounter(counterContainer, flickitySlider);
                                    }
                                    //add created slider to list, in order to return it when the function is called
                                    createdSlidersArray.push(flickitySlider);
                                }
                            }
                            else {
                                carousel.classList.add("is-not-slider");
                                carousel.setAttribute("data-carousel", "not-active");
                            }
                        }
                    });
                }
            }
        };
    }
    /**
     *  BIND FLICKITY BUTTONS
     *
     *  If there is a custom button content, it sets them as slider buttons.
     *  Insert data-button-next and data-button-previous to the elements of the button container.
     */
    bindFlickityButtons(buttonsContainer, flickitySlider) {
        if (buttonsContainer && flickitySlider) {
            const buttonNext = buttonsContainer.querySelector("[data-button-next]");
            const buttonPrevious = buttonsContainer.querySelector("[data-button-previous]");
            buttonNext.addEventListener("click", () => {
                flickitySlider.next();
            });
            buttonPrevious.addEventListener("click", () => {
                flickitySlider.previous();
            });
        }
    }
    /**
     *  BIND FLICKITY COUNTER
     *
     *  If there is a custom counter content, it sets them as slider counter.
     *  Insert data-counter to html element.
     */
    bindFlickityCounter(counterContainer, flickitySlider) {
        if (counterContainer && flickitySlider) {
            const updateStatus = () => {
                const slideNumber = flickitySlider.selectedIndex + 1;
                counterContainer.innerHTML = `${slideNumber} / ${flickitySlider.slides.length}`;
            };
            updateStatus();
            flickitySlider.on('select', updateStatus);
        }
    }
}
